import type { SVGProps } from 'react';
const SvgIconRocket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <g fill="currentColor" clipPath="url(#icon-rocket_svg__a)">
      <path d="M8 9a.75.75 0 0 1 .75.75v1.5l-.004.077a.75.75 0 0 1-1.492 0l-.004-.078v-1.5A.75.75 0 0 1 8 9m1.25-3.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5z" />
      <path
        fillRule="evenodd"
        d="M10 15.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V15h-.25a2.75 2.75 0 0 1-2.644-2H2.25A1.75 1.75 0 0 1 .5 11.25V9.164c0-.464.185-.91.513-1.238L3 5.94v-.861c0-.73.29-1.43.806-1.945L5.349 1.59l.14-.132a3.75 3.75 0 0 1 5.162.132l1.543 1.543.183.202c.4.49.623 1.105.623 1.743v.861l1.987 1.987c.328.328.513.774.513 1.238v2.085A1.75 1.75 0 0 1 13.75 13h-.856a2.75 2.75 0 0 1-2.644 2H10zM9.59 2.65a2.25 2.25 0 0 0-3.18 0L4.865 4.195a1.25 1.25 0 0 0-.366.884v7.171c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25V5.078c0-.29-.101-.57-.283-.792l-.083-.092zM2.074 8.988A.25.25 0 0 0 2 9.164v2.085c0 .139.112.25.25.25H3V8.06zM13 11.499h.75a.25.25 0 0 0 .25-.25V9.165a.25.25 0 0 0-.073-.177L13 8.06z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-rocket_svg__a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconRocket;
